<template>
  <div class="text-c">
    <van-nav-bar title="支付结果检测" left-arrow />
    <van-image :src="imgSrc" style="width: 50%; margin-top: 30%"></van-image>
    <p>检测支付结果</p>
    <van-button
      type="danger"
      @click="testing"
      class="m-l-03 b-r-013 goLook m-t-04"
      >检测</van-button
    >
    <p @click="goHome" class="m-t-04" style="font-size: 0.8rem; color: #fd7d15">
      回首页
    </p>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { getOrderByApplyNo } from "@/model/pay/payServer";

export default {
  data() {
    return {
      imgSrc: require("@/assets/imgs/empty/pay.png"),
    };
  },
  created() {
    this.testing();
  },
  methods: {
    // 检测支付结果
    testing() {
      this.orderNumber = this.$route.query.orderNumber;
      getOrderByApplyNo({ orderNumber: this.orderNumber }).then((data) => {
        if (data.data.state == 2) {
          Dialog.confirm({
            message: "支付成功",
            confirmButtonText: "去资料详情",
            cancelButtonText: "回首页",
          })
            .then(() => {
              this.$router.push({
                path: "/BIMDetials",
                query: {
                  isPay: true,
                  pid: this.$route.query.pid,
                },
              });
            })
            .catch(() => {
              this.$router.push({
                path: "/",
              });
            });
        } else {
          Dialog.confirm({
            message: "支付失败",
            confirmButtonText: "重新支付",
          })
            .then(() => {
              this.$router.push({
                path: "/",
              });
            })
            .catch(() => {
              this.$router.push({
                path: "/",
              });
            });
        }
      }).catch(() => {
        Dialog.confirm({
            message: "支付失败",
            confirmButtonText: "重新支付",
          })
            .then(() => {
              this.$router.push({
                path: "/",
              });
            })
            .catch(() => {
              this.$router.push({
                path: "/",
              });
            });
      });
    },
    goHome() {
      this.$router.push({
        path: "/",
      });
    },

    goDataList() {
      this.$router.push({
        path: "/BIMDetials",
        query: {
          isPay: true,
          pid: this.$route.query.pid,
        },
      });
    },
  },
};
</script>

<style scoped>
.goLook {
  background: linear-gradient(90deg, #fd7b11 0%, #ff9546 100%);
  box-shadow: 0rem 0.3rem 0.55rem 0rem rgba(253, 125, 20, 0.4);
  border-radius: 1.3rem;
  width: 8.15rem;
  border: none;
}
</style>